import React from "react";
import classnames from "classnames";
import styles from "./Skeleton.module.scss";

export interface SkeletonProps {
    width?: number | string;
    height?: number | string;
    /** Круг (фото), по умолчанию — скруглённый прямоугольник строки */
    circle?: boolean;
    className?: string;
}

/**
 * Заготовка на месте данных, пока они грузятся: серая плашка нужного размера.
 * Для скринридера скрыта — состояние загрузки объявляет сам экран.
 */
export const Skeleton = ({ width = "100%", height = 16, circle, className }: SkeletonProps) => (
    <span
        className={classnames(styles.skeleton, { [styles.circle]: circle }, className)}
        style={{ width, height }}
        aria-hidden="true"
    />
);
